import React, { useState } from "react";
import axios from "axios";
import FormularzZlecenia from "../zlecenia/FormularzZlecenia";
import SzczegolyKlientaTabela from "../zlecenia/SzczegolyZleceniaTabela";
import './OknoUmawianiaPrzegladu.css'

const API_URL = process.env.REACT_APP_API_URL;

function OknoUmawianiaPrzegladu({ klient, uzytkownik, onClose }) {
  const [krok, setKrok] = useState(1);
  const [kontaktData, setKontaktData] = useState(klient.kontakt || "");
  const [celKontaktu, setCelKontaktu] = useState(klient.cel_kontaktu || "");
  const [pokazFormularzZlecenia, setPokazFormularzZlecenia] = useState(false);
  const [wybranaOpcja, setWybranaOpcja] = useState(null);

  const [rezygnacja, setRezygnacja] = useState(klient.rezygnacja_z_przegladow || false);
  const [powodRezygnacji, setPowodRezygnacji] = useState(klient.powod_rezygnacji || "");

  // Aktualizacja klienta w bazie
  const zapiszDaneKlienta = async (zmiany) => {
    try {
      const token = localStorage.getItem("token");
      // Usuwamy pola, których schemat nie dopuszcza
      const {
        id_klient,
        data_dodania,
        data_ostatniej_modyfikacji,
        adresy,        
        ...restKlient
      } = klient;

      restKlient.rezygnacja_z_przegladow = !!restKlient.rezygnacja_z_przegladow;
      const payload = { ...restKlient, ...zmiany };

      await axios.put(`${API_URL}/klienci/${klient.id_klient}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (err) {
      console.error("Błąd zapisu danych klienta:", err);
      alert("Nie udało się zapisać zmian klienta.");
    }
  };

  // KROK 1: Czy klient odebrał?
  const renderKrok1 = () => (
    <div className="steps-content">
      <h3>Czy klient odebrał telefon?</h3>
      <button onClick={() => setKrok(3)}>Tak</button>
      <button onClick={() => setKrok(2)}>Nie</button>
    </div>
  );

  // KROK 2: Klient nie odebrał – planujemy kolejny kontakt
  const renderKrok2 = () => (
    <div className="steps-content">
      <h3>Kiedy planujesz kolejny kontakt?</h3>
      <input 
        type="date" 
        value={kontaktData} 
        onChange={(e) => setKontaktData(e.target.value)} 
      />
      <label>Cel kontaktu</label>
      <textarea 
        value={celKontaktu}
        onChange={(e) => setCelKontaktu(e.target.value)}
      />
      <div>
        <button onClick={() => setKrok(1)}>Wstecz</button>
        <button onClick={zapiszKrok2}>Zapisz</button>
      </div>
    </div>
  );

  const zapiszKrok2 = async () => {
    // Zapisz w DB: kontakt = kontaktData, cel_kontaktu = celKontaktu
    await zapiszDaneKlienta({
      kontakt: kontaktData || null, 
      cel_kontaktu: celKontaktu
    });
    onClose(); 
  };

  // KROK 3: Czy klient chce przegląd?
  const renderKrok3 = () => (
    <div className="steps-content">
      <h3>Czy klient chce przegląd?</h3>
      <button onClick={wybierzPrzegladTak}>Tak</button>
      <button onClick={wybierzPrzegladNie}>Nie</button>
      <button onClick={() => setKrok(1)}>Wstecz</button>
    </div>
  );

  const wybierzPrzegladTak = () => {
    // Zamiast od razu wyświetlać formularz zleceń, przechodzimy do kolejnego kroku (5)
    setKrok(5);
  };

  const wybierzPrzegladNie = () => {
    // Przechodzimy do kolejnego pod-pytania: Wykreślić czy umówić?
    setKrok(4);
  };

  // KROK 4: Wykreślić z listy czy umówić inny termin
  const renderKrok4 = () => (
    <div className="steps-content">
      <h3>Klient nie chce przeglądu</h3>
      <button onClick={() => setWybranaOpcja("rezygnacja")}>
        Wykreśl klienta z listy przeglądowej
      </button>
      <button onClick={() => setWybranaOpcja("umow")}>
        Umów inny termin kontaktu
      </button>
      <button onClick={() => setKrok(3)}>Wstecz</button>
  
      {wybranaOpcja === "rezygnacja" && renderPowodRezygnacji()}
      {wybranaOpcja === "umow" && renderInnyTermin()}
    </div>
  );
  
  // Pod-scenariusz: klient rezygnuje
  const renderPowodRezygnacji = () => (
    <div className="steps-content">
      <label>Podaj powód rezygnacji:</label>
      <textarea
        value={powodRezygnacji}
        onChange={(e) => setPowodRezygnacji(e.target.value)}
      />
      <div>
        <button onClick={zapiszRezygnacje}>Zapisz</button>
      </div>
    </div>
  );

  const zapiszRezygnacje = async () => {
    await zapiszDaneKlienta({
      rezygnacja_z_przegladow: true,
      powod_rezygnacji: powodRezygnacji
    });
    onClose(); 
  };

  // Pod-scenariusz: umów inny termin
  const renderInnyTermin = () => (
    <div className="steps-content">
      <h4>Kiedy planujesz kolejny kontakt?</h4>
      <input 
        type="date" 
        value={kontaktData}
        onChange={(e) => setKontaktData(e.target.value)}
      />
      <label>Cel kontaktu</label>
      <textarea 
        value={celKontaktu}
        onChange={(e) => setCelKontaktu(e.target.value)}
      />
      <div>
        <button onClick={() => setKrok(4)}>Wstecz</button>
        <button onClick={zapiszKrok2}>Zapisz</button>
      </div>
    </div>
  );

  // KROK 5: Ustaw datę kolejnego kontaktu i cel kontaktu, a następnie utwórz zlecenie
  const renderKrok5 = () => (
    <div className="steps-content">
      <h3>Ustal datę kolejnego kontaktu i cel kontaktu, a następnie utwórz zlecenie.</h3>
      <label>Data kolejnego kontaktu:</label>
      <input 
        type="date" 
        value={kontaktData}
        onChange={(e) => setKontaktData(e.target.value)}
      />
      <label>Cel kontaktu:</label>
      <textarea 
        value={celKontaktu}
        onChange={(e) => setCelKontaktu(e.target.value)}
      />
      <div>
        <button onClick={() => setKrok(3)}>Wstecz</button>
        <button onClick={handleZapiszZlecenie}>Zapisz</button>
      </div>
    </div>
  );

  // Po kliknięciu "Zapisz" w kroku 5 – najpierw zapisujemy w bazie datę i cel kontaktu,
  // a następnie wyświetlamy formularz zleceń.
  const handleZapiszZlecenie = async () => {
    await zapiszDaneKlienta({
      kontakt: kontaktData || null,
      cel_kontaktu: celKontaktu
    });
    setPokazFormularzZlecenia(true);
  };

  // Po zakończeniu FormZlecenia – zamykamy okno
  const handleZlecenieZamknij = () => {
    setPokazFormularzZlecenia(false);
    onClose(); 
  };

  // Główne przełączanie kroków
  const renderKrok = () => {
    switch (krok) {
      case 1: return renderKrok1();
      case 2: return renderKrok2();
      case 3: return renderKrok3();
      case 4: return renderKrok4();
      case 5: return renderKrok5();
      default: return null;
    }
  };

  return (
    <div className="modal">
      <div className="modal-content large-modal">
        <button className="close-button" onClick={onClose}>X</button>
  
        {/* Sekcja przycisków kroków */}
        <div className="step-navigation highlight-steps">
          <div className="step-buttons-bar">
            {renderKrok()}
          </div>
        </div>
  
        {/* Sekcja podsumowania klienta i adresów */}
        <div className="summary-container">
          
          {/* Dane klienta */}
          <div className="client-summary card highlight">
            <h2 className="client-name">{klient.imie} {klient.nazwisko}</h2>
            <p className="client-group"> {"(" + klient.grupa_kliencka + ")"} </p>
            <div className="client-basic-info">
                <span><strong>Telefon:</strong> {klient.nr_telefonu || '-'}</span>
                <span><strong>Email:</strong> {klient.adres_email || '-'}</span>
                <span><strong>Data dodania:</strong> {klient.data_dodania ? new Date(klient.data_dodania).toLocaleDateString() : '-'}</span>
                <span><strong>Status:</strong> {klient.status}</span>
                <span><strong>Rabat:</strong> {klient.rabat ? klient.rabat + '%' : '-'}</span>
            </div>

            <div className="note-and-contact-wrapper">
              {klient.czy_firma && (
                  <div className="client-company-info">
                  <span><strong>NIP:</strong> {klient.nip || '-'}</span>
                  <span><strong>REGON:</strong> {klient.regon || '-'}</span>
                  <span><strong>Nr konta:</strong> {klient.numer_konta || '-'}</span>
                  </div>
              )}
            
              <div className="client-note">
                  <strong>Notatka:</strong> {klient.notatka || '-'}
              </div>
              <div className="client-contact-info">
                  <span><strong>Cel kontaktu: </strong>{klient.cel_kontaktu || '-'} </span>
                  <span><strong>Kiedy kontakt: </strong>{klient.kontakt ? new Date(klient.kontakt).toLocaleDateString() : '-'} </span>
              </div>
            </div>

          </div>
  
          {/* Adresy i urządzenia */}
          <div className="section-grid">
          <div className="address-summary card">
            <h4>Adresy</h4>
            {klient.adresy && klient.adresy.length > 0 ? (
              <div className="addresses-container">
                {klient.adresy.map((adres) => (
                  <div className="address-card" key={adres.id_adres}>
                    <h5>Adres</h5>
                    <p>
                      <strong>Miasto:</strong> {adres.miasto}<br/>
                      <strong>Ulica:</strong> {adres.ulica} {adres.nr_domu}
                      {adres.nr_lokalu ? `, lok. ${adres.nr_lokalu}` : ''}<br/>
                      <strong>Kod pocztowy:</strong> {adres.kod_pocztowy}<br/>
                      <strong>Notatka:</strong> {adres.notatka || '-'}
                    </p>
                    <div className="devices-container scrollable">
                      <h6>Urządzenia</h6>
                      {adres.urzadzenia && adres.urzadzenia.length > 0 ? (
                        <ol className="devices-list">
                        {adres.urzadzenia
                          .filter(u => u.id_adres === adres.id_adres)
                          .map(u => (
                            <li key={u.id_urzadzenie} className="device-item">
                              <p><strong>{u.nazwa}</strong> {u.model} (SN: {u.numer_seryjny})</p>
                              <p>{u.typ} / {u.rodzaj}</p>
                              <p><strong>Interwał:</strong> {u.interwal_przegladow}</p>
                              <p>
                                <strong>Data montażu:</strong> {u.data_montazu ? new Date(u.data_montazu).toLocaleDateString() : '-'}<br/>
                                <strong>Ostatni przegląd:</strong> {u.data_ostatniego_przegladu ? new Date(u.data_ostatniego_przegladu).toLocaleDateString() : '-'}
                              </p>
                              <p><strong>Uwagi:</strong> {u.uwagi || '-'}</p>
                            </li>
                          ))
                        }
                      </ol>
                      
                      ) : (
                        <p className="no-devices">Brak urządzeń dla tego adresu.</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>Brak adresów.</p>
            )}
          </div>
          
           <SzczegolyKlientaTabela 
            uzytkownik={uzytkownik}
            klientId={klient.id_klient}
            klientData={klient}
            adresData={klient.adresy}
           />
          </div>
        </div>
  
        {/* Jeśli formularz zleceń jest otwarty */}
        {pokazFormularzZlecenia && (
          <FormularzZlecenia
            uzytkownik={uzytkownik}
            onZamknij={handleZlecenieZamknij}
            clientId={klient.id_klient}
          />
        )}
      </div>
    </div>
  );
}

export default OknoUmawianiaPrzegladu;
